export const CHANGE_PAGE = 'CHANGE_PAGE';
export const OUTER_STATE = 'OUTER_STATE';
